module.exports = __webpack_public_path__ + "static/img/other.2c804c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other.png
// module id = Lvvg
// module chunks = 1